import { useEffect, useState } from "react";
import axios from "axios";
import { ARTICLES } from "@/data/articles";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useBlog = () => {
  const [posts, setPosts] = useState(null);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    let alive = true;
    Promise.all([axios.get(`${API}/blog/posts`, { timeout: 15000 }), axios.get(`${API}/blog/videos`, { timeout: 15000 })])
      .then(([p, v]) => { if (alive) { setPosts(p.data); setVideos(v.data); } })
      .catch(() => { if (alive) setPosts([]); });
    return () => { alive = false; };
  }, []);

  const published = posts || [];
  const publishedSlugs = new Set(published.map((p) => p.slug));
  const placeholders = ARTICLES.filter((a) => !publishedSlugs.has(a.slug)).map((a) => ({ ...a, placeholder: true }));

  return { loading: posts === null, published, articles: [...published, ...placeholders], videos };
};
